import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { IdentityService } from 'src/app/core/identity-storage.service';
import { EmployeeHttpClient } from 'src/app/shared/flight-log-api/employees/employee-client.service';
import {
  IdentityActionTypes,
  IdentityAuthenticated,
  IdentityLoaded,
} from 'src/store/identity/identity.actions';

@Injectable()
export class IdentityEffects {
  constructor(
    private actions$: Actions,
    private _employeeClient: EmployeeHttpClient,
    private _idStore: IdentityService,
  ) {}

  @Effect()
  public onAuth = this.actions$.pipe(
    ofType<IdentityAuthenticated>(IdentityActionTypes.IdentityAuthenticated),
    map(({ payload: { identity: id } }) => id),
    tap((id) => this._idStore.set(id)),
    map((id) => new IdentityLoaded({ identity: id })),
  );
}
